import { getLeaveList } from "../../services/workspace/leave.service";
import { createStaffAttendance, getStaffAttendanceByDate, getStaffDetail, updateStaffAttendance } from "../../services/workspace/staff.service";
import { _setStaffDetail, _setStaffLoading } from "../slices/staff.slice";
import { _setActiveAttendance } from "../slices/user.slice";

export const _retrieveStaffDetails = (id = null, refresh = false) => async (dispatch) => {
  try {
    if (!refresh) {
      dispatch(_setStaffLoading(true));
    }
    const result = await getStaffDetail(id);
    const response = result;

    if (response) { 
      dispatch(_setStaffDetail(response));
    } else {
      dispatch(_setStaffDetail(null));
    }
    dispatch(_setStaffLoading(false));
  } catch (error) {
    dispatch(_setStaffLoading(false));

    console.error("An error occurred while fetching staff data:", error);
  }
};


//fetching active attendance
export const _fetchActiveAttendance = (callback = () => null) => async (dispatch) => {
  try {
    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];
    const response = await getStaffAttendanceByDate(today)
    
    // API returns { attendance: {...} } - convert to array format
    let attendanceArray = [];
    if (response?.attendance) {
      // Single attendance object - convert to array
      attendanceArray = [response.attendance];
    } else if (response?.data) {
      // Check if data is array or object
      if (Array.isArray(response.data)) {
        attendanceArray = response.data;
      } else if (response.data.attendance) {
        attendanceArray = [response.data.attendance];
      }
    }
    
    dispatch(_setActiveAttendance(attendanceArray))
    callback(false, null)
  } catch (error) {
    callback(true, error)
    console.error("An error occurred while fetching the active attendance :", error);
    // Set empty array on error to prevent crashes
    dispatch(_setActiveAttendance([]))
  }
};

//start attendance
export const _startStaffAttendance = (data, callback = () => null) => async (dispatch) => {
  try {
    const response = await createStaffAttendance(data)
    // API returns { attendance: {...} } or { data: { attendance: {...} } }
    // Extract the attendance object
    const attendanceData = response.data?.attendance || response.data;
    if (attendanceData) {
      callback(false, attendanceData)
    }
  } catch (error) {
    callback(true, error)
    console.error("An error occurred while create staff attendance :", error);
  }
};

//end attendance
export const _endStaffAttendance = (id, data, callback = () => null) => async (dispatch) => {
  try {
    const response = await updateStaffAttendance(id, data)
    if (response.data) {
      callback(false, response.data)
    }
  } catch (error) {
    callback(true, error)
    console.error("An error occurred while udpate staff attendance :", error);
  }
};
